import { createSlice } from "@reduxjs/toolkit";

import { type SubCategoryStateType } from "../interfaces/subcategory";

const initialState: SubCategoryStateType = {
  isLoading: false,
  subCategories: [],
};

const subCategorySlice = createSlice({
  name: "subCategory",
  initialState,
  reducers: {
    setSubCategoryLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSubCategories: (state, action) => {
      state.subCategories = action.payload;
    },
  },
});

export const { setSubCategoryLoading, setSubCategories } =
  subCategorySlice.actions;
export default subCategorySlice.reducer;
